<template>
  <div class="general-frame">
    <div
      style="height: 100%; width: 100%;
        padding: 2%;
        box-sizing: border-box;
        color: #fff;
        background: #0d274d;
      "
      class="flex"
    >
      <div style="width: 60%; height: 100%; text-align: left">
        <div style="height: 100%" class="flex-bottom">
          <div style="height: 100%">
            <div
              style="height: 7%; margin-bottom: 15px"
              class="toiletIng flex the_boxshadow k_b1"
            >
              <i class="k_top_left"></i>
              <i class="k_top_right"></i>
              <i class="k_bottom_left"></i>
              <i class="k_bottom_rigth"></i>
              <ToiletSelect
                :toiletId="toiletId"
                :toiletType="2"
                :width="'80%'"
                @getId="res => {
                  toiletId = res;
                  methodBody();
                }"
              />
              <div
                class="graphical_button flex boxsize"
                style="width: 27%; height: 80%; padding: 0"
              >
                <button
                  @click="changeStyle(1)"
                  :class="{ active1: active == 1 }"
                  style="white-space: nowrap"
                >
                  真空设备
                </button>
                <button
                  @click="changeStyle(2)"
                  :class="{ active1: active == 2 }"
                  style="white-space: nowrap"
                >
                  厕位占用
                </button>
                <svg style="width: 11%;" class="icon icon-x" aria-hidden="true">
                  <use xlink:href="#icon-Downxiangxia34"></use>
                </svg>
              </div>
            </div>

            <div
              class="the_boxshadow k_b1"
              style="height: calc(78% - 30px); margin-bottom: 15px"
            >
              <i class="k_top_left"></i>
              <i class="k_top_right"></i>
              <i class="k_bottom_left"></i>
              <i class="k_bottom_rigth"></i>
              <toiletOccupy v-show="active == 2" :id="toiletId"></toiletOccupy>
              <div
                class="flex-center kg100"
                style="overflow: auto"
                v-show="active == 1"
              >
                <div class="vacuuume-sb">
                  <div class="kg100 vacuuume-bj"></div>
                  <ul
                    v-for="(item, index) in vacuumEquipment"
                    :key="index"
                    :class="`style_${item.id}`"
                  >
                    <li
                      class="runyesimg flex-center"
                      :class="{
                        blink_1: VcData[`toilet${index + 1}Fault`],
                        waringimg: VcData[`toilet${index + 1}Fault`]
                      }"
                    >
                      <div
                        style="background-color: #000; width: 7px; height: 3px"
                      ></div>
                    </li>
                    <li
                      class="normal1"
                      :class="{
                        abnormal1: VcData[`toilet${index + 1}Fault`],
                        marright: item.id == 4 || item.id == 5 || item.id == 9,
                        marleft: !(
                          item.id == 4 ||
                          item.id == 5 ||
                          item.id == 9
                        ),
                        martop: item.id == 3 || item.id == 9
                      }"
                    >
                      真空{{
                        item.id == 3
                          ? "坐便"
                          : item.id == 8
                          ? "坐便"
                          : item.id == 9
                          ? "坐便"
                          : "蹲便"
                      }}{{ item.id }}
                    </li>
                  </ul>
                  <div class="pressure-value flex-center">
                    <span>{{ VcData.vacuumValue.toFixed(1) }}kpa</span>
                  </div>
                  <div class="equipment flex" v-show="pump[toiletId]">
                    <template v-for="(item, index) in pump[toiletId]">
                      <div
                        class="flex-center pumpImg"
                        :class="{
                          abnormal1: VcData[`${item}pumpFault`] == 1,
                          blink_1:
                            VcData[`${item}pumpFault`] == 1 || VcData[`${item}pumpStatus`] == statusInverse[toiletId][0],
                          runnoimg:
                            VcData[`${item}pumpFault`] == 0 && VcData[`${item}pumpStatus`] == statusInverse[toiletId][0],
                          runyesimg:
                            VcData[`${item}pumpFault`] == 0 && VcData[`${item}pumpStatus`] == statusInverse[toiletId][1]
                        }"
                      >
                        <div
                          style="background-color: #000; width: 7px; height: 3px"
                        ></div>
                      </div>
                      <span
                        :class="{
                          abnormal1: VcData[`${item}pumpFault`] == 1,
                          runings:
                            VcData[`${item}pumpFault`] == 0 && VcData[`${item}pumpStatus`] == statusInverse[toiletId][0],
                          normal1:
                            VcData[`${item}pumpFault`] == 0 && VcData[`${item}pumpStatus`] == statusInverse[toiletId][1]
                        }"
                        >泵{{ index + 1 }}</span
                      >
                    </template>
                  </div>
                  <ul class="flexcz example">
                    <li class="runyesimg flex-center">
                      <div
                        style="background-color: #000; width: 7px; height: 3px"
                      ></div>
                    </li>
                    <span class="runyes">正常</span>
                    <li class="runnoimg blink_1 flex-center">
                      <div
                        style="background-color: #000; width: 7px; height: 3px"
                      ></div>
                    </li>
                    <span style="color: #fff">运行</span>
                    <li class="waringimg blink_1 flex-center">
                      <div
                        style="background-color: #000; width: 7px; height: 3px"
                      ></div>
                    </li>
                    <span style="color: #fa1818">通讯异常</span>
                  </ul>
                </div>
              </div>
            </div>
            <div
              v-if="deodoriser1.length > 0 && deodoriser2.length > 0"
              class="the_boxshadow k_b1 flex boxsize"
              style="
                height: 15%;
                padding: 8px;
                background-color: rgba(13, 41, 75, 0.3);
              "
            >
              <i class="k_top_left"></i>
              <i class="k_top_right"></i>
              <i class="k_bottom_left"></i>
              <i class="k_bottom_rigth"></i>
              <div style="width: 15%; height: 100%">
                <div
                  class="flexcz borders the_boxshadow"
                  style="
                    padding: 0 0 5px 0;
                    box-sizing: border-box;
                    width: 100%;
                    height: 100%;
                    background-color: rgb(12, 58, 101);
                  "
                >
                  <div
                    class="flex-center"
                    style="
                      width: 100%;
                      height: 30%;
                      font-size: 1.13vw;
                      color: #fff;
                    "
                  >
                    <span>除臭机状态</span>
                  </div>

                  <div
                    class="flexcz"
                    style="font-size: 1.2vw; width: 100%; height: 70%"
                  >
                    <span style="color: #fff; margin-top: 5px"
                      >男：<span
                        :class="deodoriser1[0].isOnline ? 'normal' : 'abnormal'"
                        ><span style="font-family: 'nmb'"
                          >{{ deodoriser1[0].isOnline ? "在线" : "离线" }}
                        </span></span
                      ></span
                    >
                    <span style="color: #fff"
                      >女：<span
                        :class="deodoriser2[0].isOnline ? 'normal' : 'abnormal'"
                        ><span style="font-family: 'nmb'">{{
                          deodoriser2[0].isOnline ? "在线" : "离线"
                        }}</span></span
                      ></span
                    >
                  </div>
                </div>
              </div>
              <div
                class="flex the_boxshadow"
                style="
                  width: calc(85% - 5px);
                  margin-left: 5px;
                  height: 100%;
                  background-color: rgb(12, 58, 101);
                  border-radius: 10px;
                "
              >
                <deodorizer-status
                  :title="'清洗'"
                  :icon="'#icon-qingxi'"
                  :status1="deodoriser1[0].isNeedClean"
                  :status2="deodoriser2[0].isNeedClean"
                ></deodorizer-status>
                <deodorizer-status
                  :title="'堵转'"
                  :icon="'#icon-weibiaoti-'"
                  :status1="deodoriser1[0].isStall"
                  :status2="deodoriser2[0].isStall"
                ></deodorizer-status>
                <deodorizer-status
                  :title="'停水'"
                  :icon="'#icon-shidu1'"
                  :status1="deodoriser1[0].isLackOfWater"
                  :status2="deodoriser2[0].isLackOfWater"
                ></deodorizer-status>
                <deodorizer-status
                  :title="'缺液'"
                  :icon="'#icon-huaban-'"
                  :status1="deodoriser1[0].isLiquidDeficiency"
                  :status2="deodoriser2[0].isLiquidDeficiency"
                ></deodorizer-status>
                <div
                  class="flexcz chouchouji_list the_boxshadow"
                  style="padding: 0 0 5px 0; box-sizing: border-box"
                >
                  <div>植物液余数</div>

                  <div
                    class="flexcz"
                    style="font-size: 1.3vw; width: 100%; height: 70%"
                  >
                    <span
                      >男：<span
                        :class="
                          deodoriser1[0].remainNum < 0.15
                            ? 'abnormal'
                            : 'normal'
                        "
                        ><span style="font-family: 'nmb'"
                          >{{
                            Math.round(deodoriser1[0].remainNum * 100)
                          }} </span
                        >%</span
                      >
                    </span>
                    <span
                      >女：<span
                        :class="
                          deodoriser2[0].remainNum < 0.15
                            ? 'abnormal'
                            : 'normal'
                        "
                        ><span style="font-family: 'nmb'"
                          >{{
                            Math.round(deodoriser2[0].remainNum * 100)
                          }} </span
                        >%</span
                      >
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="width: 36%; height: 100%; text-align: left"
        class="flex-bottom"
      >
        <div style="height: 30%">
          <div class="flex" style="height: 25%">
            <div class="graphical_button graphical_title">当日使用人数</div>
          </div>
          <div
            class="k_b1 the_boxshadow"
            style="height: 75%; box-sizing: border-box"
          >
            <i class="k_top_left"></i>
            <i class="k_top_right"></i>
            <i class="k_bottom_left"></i>
            <i class="k_bottom_rigth"></i>
            <el-row :gutter="20">
              <el-col :span="12" :offset="6">
                <div class="detail-2-text detail-2-top">
                  {{ toiletOneDataList.peoNumToDay || 0 }}
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12" :offset="6">
                <div class="detail-2-text detail-2-bottom">
                  当日累计使用人数
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div style="height: 30%">
          <div class="flex" style="height: 25%">
            <div class="graphical_button graphical_title">当前空闲间数</div>
          </div>
          <div class="k_b1 the_boxshadow" style="height: 75%">
            <i class="k_top_left"></i>
            <i class="k_top_right"></i>
            <i class="k_bottom_left"></i>
            <i class="k_bottom_rigth"></i>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-row :gutter="20">
                  <el-col :span="16" :offset="4">
                    <div
                      class="detail-2-text detail-2-top"
                      style="font-style: italic"
                    >
                      {{ toiletNumber[1].length
                      }}<span class="title_color"
                        >/{{ toiletNumber[0].length }}</span
                      >
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="16" :offset="4">
                    <div class="detail-2-text detail-2-bottom">男厕空闲数</div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12" style="border-left: 2px dashed #eee">
                <el-row :gutter="20">
                  <el-col :span="16" :offset="4">
                    <div
                      class="detail-2-text detail-2-top"
                      style="font-style: italic"
                    >
                      {{ toiletNumber[3].length
                      }}<span class="title_color"
                        >/{{ toiletNumber[2].length }}</span
                      >
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="16" :offset="4">
                    <div class="detail-2-text detail-2-bottom">女厕空闲数</div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
        <div style="height: 40%">
          <div class="flex" style="height: 18%">
            <div class="graphical_button graphical_title">公厕数据展示</div>
          </div>
          <div
            class="k_b1 the_boxshadow"
            style="height: 83%"
            v-if="toiletDataList.length > 0"
          >
            <i class="k_top_left"></i>
            <i class="k_top_right"></i>
            <i class="k_bottom_left"></i>
            <i class="k_bottom_rigth"></i>
            <el-row :gutter="20" style="padding-top: 20px">
              <el-col :span="12">
                <el-row :gutter="20" style="margin-bottom:20px;">
                  <el-col :span="16" :offset="4">
                    <div class="detail-2-text">
                      <span class="title_color colorGreen">{{
                        (
                          toiletDataList[toiletDataList.length > 1 ? toiletDataList.length - 2 : 0].water * 1.3
                        ).toFixed(2) || 0
                      }}</span>
                    </div>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="16" :offset="4">
                    <div
                      class="detail-2-text graphical_button"
                      style="font-size: 20px;"
                    >
                      昨日排水量(t)
                    </div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12" style="border-left: 2px dashed #eee">
                <el-row :gutter="20" style="margin-bottom:20px;">
                  <el-col :span="16" :offset="4">
                    <div class="detail-2-text">
                      <span class="title_color colorGreen">{{
                        toiletOneDataList.airInfo.length > 0 ? (toiletOneDataList.airInfo[0].nh3 || 0) : "暂无"
                      }}</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="16" :offset="4">
                    <div
                      class="detail-2-text graphical_button"
                      style="font-size: 20px"
                    >
                      NH3男(ppm)
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 20px">
              <el-col :span="12">
                <el-row :gutter="20">
                  <el-col :span="16" :offset="4">
                    <div class="detail-2-text">
                      <span class="title_color colorGreen">{{
                        toiletDataList[toiletDataList.length > 1 ? toiletDataList.length - 2 : 0].electric || 0
                      }}</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-top:20px;">
                  <el-col :span="16" :offset="4">
                    <div
                      class="detail-2-text graphical_button"
                      style="font-size: 20px"
                    >
                      昨日用电(kw·h)
                    </div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12" style="border-left: 2px dashed #eee">
                <el-row :gutter="20">
                  <el-col :span="16" :offset="4">
                    <div class="detail-2-text">
                      <span class="title_color colorGreen">{{
                        toiletOneDataList.airInfo.length > 0 ? (toiletOneDataList.airInfo[0].nh3 || 0) : "暂无"
                      }}</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-top:20px;">
                  <el-col :span="16" :offset="4">
                    <div
                      class="detail-2-text graphical_button"
                      style="font-size: 20px"
                    >
                      NH3女(ppm)
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toiletOccupy from "@/components/html/toiletOccupy.vue";
import deodorizerStatus from "@/components/html/deodorizerStatus.vue";
import ToiletSelect from "@/components/html/toiletSelect.vue";
export default {
  components: { toiletOccupy, deodorizerStatus, ToiletSelect },
  data() {
    return {
      toiletId: 12,
      active: 1,
      VcData: {
        vacuumValue: 0,
        toilet1Fault: false,
        toilet2Fault: false,
        toilet3Fault: false,
        toilet4Fault: false,
        toilet5Fault: false,
        toilet6Fault: false,
        toilet7Fault: false,
        toilet8Fault: false,
        toilet9Fault: false
      },
      vacuumEquipment: [
        { id: 1, isuse: 1 },
        { id: 2, isuse: 1 },
        { id: 3, isuse: 1 },
        { id: 4, isuse: 1 },
        { id: 5, isuse: 1 },
        { id: 6, isuse: 1 },
        { id: 7, isuse: 1 },
        { id: 8, isuse: 1 },
        { id: 9, isuse: 1 }
      ],
      pump: {
        12: ['a', 'b'],
        16: ['a', 'b', 'c'],
        22: ['a', 'b'],
      },
      statusInverse: {
        12: [0, 1],
        16: [1, 0],
        22: [1, 0]
      },
      toiletList: [
        { temp: 0, rh: 0, h2s: 0, nh3: 0 },
        { temp: 0, rh: 0, h2s: 0, nh3: 0 }
      ],
      deodoriser1: [],
      toiletDataList: [],
      toiletOneDataList: {
        peoNumToDay: null,
        airInfo: [
          { temp: null, hum: null, nh3: null, h2s: null },
          { temp: null, hum: null, nh3: null, h2s: null }
        ],
        occupancy: [
          { sex: null, isOccupy: null },
          { sex: null, isOccupy: null }
        ]
      },
      deodoriser2: [
        {
          isLackOfWater: false,
          isLiquidDeficiency: false,
          isNeedClean: false,
          isOnline: false,
          isStall: false,
          remainNum: 2
        }
      ],
      toiletInfoList: [],
      toiletLocation: [],
      interval2: null,
      legend: {
        male: require("../../../img/baseImg/male#fff.svg"),
        female: require("../../../img/baseImg/female#fff.svg")
      }
    };
  },
  methods: {
    getListCountByOne() {
      // 单厕所7天数据
      this.get("toiletData/listCountByOne", {
        toiletId: this.toiletId
      }).then(res => {
        if (res.data.rows.length) {
          this.toiletDataList = res.data.rows;
        }
      });
    },
    getToiletStatisticalData() {
      //获取厕所单日统计数据
      this.get("toiletInfo/detail", { id: this.toiletId }).then(res => {
        if (res.data.data) {
          this.toiletOneDataList = res.data.data;
        }
      });
    },
    getDeodorantMachine() {
      //除臭机数据
      this.get("deodorantMachine/queryList", { toilet_id: this.toiletId }).then(
        res => {
          if (res.data.data) {
            this.deodoriser1 = res.data.data.filter(function(filter) {
              return filter.gender == 1;
            });
            this.deodoriser2 = res.data.data.filter(function(filter) {
              return filter.gender == 2;
            });
          } else {
            this.deodoriser1 = [];
            this.deodoriser2 = [];
          }
        }
      );
    },
    changeStyle(e) {
      if (e == 1) {
        this.active = 1;
      } else {
        this.active = 2;
      }
    },
    getZKData() {
      this.get("vacuumData/realtimeVacuum", {toiletId: this.toiletId}).then(res => {
        if(Object.keys(res.data.data).length == 0) {
          this.$message.error("获取数据失败");
        }
        this.VcData = res.data.data;
      });
    },
    //请求方法
    methodBody() {
      this.getDeodorantMachine();
      this.getToiletStatisticalData();
      this.getListCountByOne();
      this.getZKData();
    }
  },
  mounted() {
    this.toiletId =
      this.$route.query.id == null ? 12 : parseInt(this.$route.query.id);
    this.methodBody();
    if (this.interval2) clearInterval(this.interval2);
    this.interval2 = setInterval(() => {
      this.getDeodorantMachine();
      this.getListCountByOne();
      this.getZKData();
      this.getToiletStatisticalData();
    }, 1000 * 4);
  },
  computed: {
    toiletNumber() {
      let man = this.toiletOneDataList.occupancy.filter(function(item) {
        return item.sex == 1;
      });
      let wman = this.toiletOneDataList.occupancy.filter(function(item) {
        return item.sex == 2;
      });
      let manYes = man.filter(function(item) {
        return item.isOccupy == false;
      });
      let wmanYes = wman.filter(function(item) {
        return item.isOccupy == false;
      });
      let numbers = [man, manYes, wman, wmanYes];
      return numbers;
    }
  },
  //移除事件监听，避免内存泄漏
  beforeDestroy() {
    clearInterval(this.interval2);
    this.interval2 = null;
  },
  created: function() {}
};
</script>

<style scoped>
.toiletIng /deep/ .el-input__inner {
  background-color: #0c284e;
  border: none;
  color: #fff;
  font-size: 1.1vw;
}
.graphical_button {
  border: 2px solid rgb(69, 162, 255);
  -webkit-box-shadow: rgb(198, 227, 255) 0 0 30px inset;
  box-shadow: rgb(9, 55, 97) 0 0 18px inset;
  text-align: center;
  color: #fff;
  border-radius: 8px;
  font-size: 20px;
  padding: 7px 0;
}
.graphical_title {
  width: 170px;
}
.flexcz {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.the_boxshadow {
  box-shadow: rgb(4, 91, 146) 0 0 18px inset;
}
.chouchouji_list {
  width: 19%;
  height: 100%;
  align-items: center;
  font-size: 1.1vw;
  color: #fff;
  border-radius: 10px;
}
.normal {
  color: #44ee66;
}
.abnormal {
  color: rgb(255, 11, 11);
}
.icon {
  width: 2.1vw;
  height: 2.1vw;
  fill: #fff;
}
.icon-x {
  width: 1.3vw;
  height: 1.3vw;
  fill: #78e0e3;
  margin: 0;
  padding: 0;
}

.cztext {
  font-size: 22px;
  color: #3c9fe9;
  box-shadow: rgb(4, 91, 146) 0 0 10px inset;
  background-color: rgb(12, 58, 101);
}
.borders {
  background: linear-gradient(#0053ed, #0053ed) left top,
    linear-gradient(#0053ed, #0053ed) left top,
    linear-gradient(#0053ed, #0053ed) right top,
    linear-gradient(#0053ed, #0053ed) right top,
    linear-gradient(#0053ed, #0053ed) left bottom,
    linear-gradient(#0053ed, #0053ed) left bottom,
    linear-gradient(#0053ed, #0053ed) right bottom,
    linear-gradient(#0053ed, #0053ed) right bottom;
  background-repeat: no-repeat;
  background-size: 0.1vw 0.5vw, 0.5vw 0.1vw;
}

.titleIng p {
  margin-top: 7px;
  color: #29c0dd;
  text-align: left;
}
.titleIng > div > p {
  font-size: 14px;
}
.titleIng > p {
  text-align: center;
}
.titleIng div {
  font-size: 19px;
  font-weight: 600;
}
.title_color {
  color: #fff;
  font-size: 40px;
}
.air-col-8 img {
  height: 62%;
  float: left;
  margin: 0 8% 0 8%;
}

button {
  width: 45%;
  height: 100%;
  padding: 0;
  font-size: 23px;
  cursor: pointer;
  border: none;
  outline: none;
  background: transparent;
  color: white;
  font-family: "Times New Roman", Times, serif;
  font-weight: 700;
  position: relative;
  transition: all 0.5s;
  z-index: 1;
}

button::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 100%;
  background-color: #0dede0;
  z-index: -1;
  transition: all 0.5s;
}

button:hover::before {
  width: 102%;
}

button:hover {
  color: black;
}

button:active:before {
  background: #b9b9b9;
}
.active1 {
  background-color: #0dede0;
  color: black;
}
.vacuuume-sb {
  z-index: 10;
  background-image: url(~@/img/baseImg/zksb.png);
  position: relative;
  background-repeat: no-repeat;
  width: 880px;
  height: 610px;
  background-size: 880px 610px;
  background-attachment: local;
}
.vacuuume-bj {
  z-index: 11;
  background-repeat: no-repeat;
  background-image: url(~@/img/baseImg/zksb1.gif);
  width: 880px;
  height: 610px;
  background-size: 880px 610px;
  background-attachment: local;
}
.style_1 {
  position: absolute;
  left: 0;
  top: 0px;
}
.style_2 {
  position: absolute;
  left: 0;
  top: 100px;
}
.style_3 {
  position: absolute;
  left: 0px;
  top: 210px;
}
.style_4 {
  position: absolute;
  left: 290px;
  top: 0px;
}
.style_5 {
  position: absolute;
  left: 290px;
  top: 100px;
}
.style_6 {
  position: absolute;
  left: 405px;
  top: -5px;
}
.style_7 {
  position: absolute;
  left: 560px;
  top: -5px;
}
.style_8 {
  position: absolute;
  left: 705px;
  top: -5px;
}
.style_9 {
  position: absolute;
  left: 635px;
  top: 225px;
}
.pressure-value {
  position: absolute;
  width: 70px;
  height: 33px;
  left: 150px;
  top: 430px;
  color: #39fc83;
  background-color: #0d274d;
  font-size: 23px;
}
.pumpImg {
  margin: 0 10px;
}
.equipment {
  position: absolute;
  height: 33px;
  left: 182px;
  top: 575px;
  font-size: 20px;
  font-family: "nmb";
}
.example {
  position: absolute;
  width: 52px;
  height: 233px;
  right: -10px;
  top: 225px;
  font-size: 20px;
  font-family: "nmb";
}
@keyframes blinks {
  0%,
  50%,
  100% {
    opacity: 1;
  }
  25%,
  75% {
    opacity: 0;
  }
}

.blink_1 {
  animation: blinks 1s infinite;
}
.marleft {
  margin: 5px 0 0 38px;
}
.marright {
  margin: 5px 0 0 -130px;
  direction: rtl;
}
.martop {
  margin-top: -12px;
}
.runyes {
  color: #39fc83;
  font-size: 21px;
  font-family: "nmb";
}
.runyesimg {
  width: 19px;
  height: 21px;
  background-color: #39fc83;
  color: #39fc83;
}
.runnoimg {
  width: 19px;
  height: 21px;
  background-color: #fbff20;
}
.waringimg {
  width: 19px;
  height: 21px;
  background-color: #fa1818;
}
.runings {
  color: #fbff20;
  font-size: 20px;
}
.normal1 {
  color: #39fc83;
  font-size: 20px;
}
.abnormal1 {
  color: #fa1010;
  font-size: 20px;
}
.colorGreen {
  font-size: 40px;
  color: #0dede0;
}
</style>



// WEBPACK FOOTER //
// src/pages/menu/toilet/toiletDetail2.vue